import React, { memo } from "react";
import { useTranslation } from "react-i18next";

export default memo(function UploadToast({
  isOpen,
  percent = 0,
  status = "uploading", // 'uploading' | 'paused' | 'finalizing' | 'success' | 'error'
  titleKey = "uploadToast.title",
  doneKey = "uploadToast.done",
  errorKey = "uploadToast.error",
}) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const pct = Math.max(0, Math.min(100, Number(percent) || 0));

  const label =
    status === "success"
      ? t(doneKey)
      : status === "error"
        ? t(errorKey)
        : status === "finalizing"
          ? t("uploadToast.finalizing", "Finalizing upload")
        : status === "paused"
          ? t("uploadToast.paused", "Upload paused")
          : t(titleKey);

  const hint =
    status === "uploading"
      ? t(
          "uploadToast.keepOpen",
          "Keep the web app open until the upload finishes.",
        )
      : status === "paused"
        ? t(
            "uploadToast.pausedHint",
            "The upload is waiting to resume. Keep the app open.",
          )
        : status === "finalizing"
          ? t(
              "uploadToast.finalizingHint",
              "Finalizing the upload. Please keep the app open.",
            )
          : null;

  return (
    <div
      className="
        fixed top-4 right-4 md:right-auto md:left-4 md:top-auto md:bottom-4 z-50
        w-[min(40vw,320px)]
        pointer-events-none
      "
      aria-live="polite"
    >
      <div
        className="
          custom-container
          px-3 py-2
          flex flex-col gap-1
          shadow-lg
        "
      >
        {/* Header row */}
        <div className="flex items-center justify-between gap-2">
          <p className="text-xs font-semibold text-typography truncate">
            {label}
          </p>
          {/* <span className="text-xs font-medium tabular-nums text-greyscale-3">
            {Math.round(pct)}%
          </span> */}
        </div>

        {hint ? (
          <p className="text-[11px] leading-tight text-greyscale-3">{hint}</p>
        ) : null}

        {/* Progress bar */}
        <div className="w-full h-1.5 rounded bg-tertiary/40 overflow-hidden">
          <div
            className="h-full bg-primary transition-[width] duration-200"
            style={{ width: `${pct}%` }}
          />
        </div>
      </div>
    </div>
  );
});
